import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './TabPanel.scss';
/**
 * @component TabPanel
 * @since 1.0.0
 */
export function TabPanel(props) {
    const { style, picto, label, disabled } = Object.assign({ style: 'normal' }, props);
    const className = classNames('tab-panel', 'tab-panel--' + style, { 'tab-panel--has-label': label }, { 'tab-panel--has-picto': picto }, { 'tab-panel--is-disabled': disabled }, props.className);
    return React.createElement("div", { className: className }, props.children);
}
